import React, { Component } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import moment from 'moment';
import CardLessDataTable from '../../datatables/CardLessDataTableWithSearch';

class DateWiseFeeSection extends Component {
    constructor(props) {
        super(props);
        const today = moment().format('YYYY-MM-DD');
        this.state = {
            fromDate: today,
            toDate: today,
            showModal: false,
            selectedRow: null,
        };
    }

    getDateWiseRows = () => {
        const { fromDate, toDate } = this.state;
        const from = moment(fromDate).startOf('day');
        const to = moment(toDate).endOf('day');
        const rows = [];

        (this.props.getStudentPaymentDetails || []).forEach((student) => {
            (student.term_details || []).forEach((termDetail) => {
                (termDetail.terms || []).forEach((term) => {
                    if (term.is_paid != 1 || !term.paid_date) return;
                    const paidMoment = moment.unix(parseInt(term.paid_date));
                    if (!paidMoment.isBetween(from, to, null, '[]')) return;

                    const paymentMode = this.props.getPaymentModes
                        ? (this.props.getPaymentModes.find(p => p.id == term.payment_mode_id) || {}).payment_mode || '-'
                        : '-';
                    const feeType = (this.props.globals.offlineFeeTypes || []).find(f => f.id == termDetail.fee_type_id);

                    rows.push({
                        paid_date: paidMoment.format('DD-MM-YYYY'),
                        paid_date_raw: parseInt(term.paid_date),
                        student_name: student.student_name,
                        roll_no: student.roll_no,
                        class_name: student.class_name,
                        section_name: student.section_name,
                        branch_name: student.branch_name,
                        exam_name: student.exam_name,
                        fee_type: feeType ? feeType.fee_type : '-',
                        term_no: term.term_no == 0 ? 'Initial' : `Term ${term.term_no}`,
                        term_amount: term.term_amount,
                        payment_mode: paymentMode,
                        comments: term.comments || '-',
                        payment_id: term.payment_id || '-',
                        // full term list for the modal
                        all_terms: termDetail.terms,
                        no_of_terms: termDetail.no_of_terms,
                        total_amount: termDetail.total_amount,
                        student_mobile: student.student_mobile,
                    });
                });
            });
        });

        rows.sort((a, b) => b.paid_date_raw - a.paid_date_raw);
        return rows;
    };

    openModal = (row) => this.setState({ showModal: true, selectedRow: row });
    closeModal = () => this.setState({ showModal: false, selectedRow: null });

    Columns() {
        return [
            {
                dataField: 'id',
                text: 'Sr. No',
                formatter: (cell, row, rowIndex) => rowIndex + 1,
            },
            { dataField: 'paid_date',    text: 'Paid Date',    sort: true },
            { dataField: 'student_name', text: 'Student Name', sort: true },
            { dataField: 'roll_no',      text: 'Adm No',       sort: true },
            { dataField: 'class_name',   text: 'Class',        sort: true },
            { dataField: 'branch_name',  text: 'Branch',       sort: true },
            { dataField: 'fee_type',     text: 'Fee Type',     sort: true },
            { dataField: 'term_no',      text: 'Term' },
            {
                dataField: 'term_amount',
                text: 'Amount (₹)',
                sort: true,
                formatter: (cell) => (
                    <span style={{ fontWeight: 600, color: '#15803d' }}>₹{cell?.toLocaleString()}</span>
                ),
            },
            { dataField: 'payment_mode', text: 'Payment Mode' },
            {
                dataField: 'action',
                text: 'Action',
                formatter: (cell, row) => (
                    <button
                        onClick={() => this.openModal(row)}
                        style={{
                            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                            border: 'none', borderRadius: 8, padding: '5px 14px',
                            fontSize: 12, fontWeight: 600, color: '#fff', cursor: 'pointer',
                        }}
                    >
                        View
                    </button>
                ),
            },
        ];
    }

    renderModal() {
        const { showModal, selectedRow } = this.state;
        if (!selectedRow) return null;

        const S = {
            label: { fontSize: 11, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 2, display: 'block' },
            value: { fontSize: 14, fontWeight: 600, color: '#1f2937' },
            infoBox: { background: '#f8fafc', borderRadius: 10, padding: '10px 14px', marginBottom: 8 },
            termCardPaid: { background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '12px 16px', marginBottom: 10, borderLeft: '4px solid #10b981' },
            termCardUnpaid: { background: '#fafafa', border: '1px solid #e5e7eb', borderRadius: 10, padding: '12px 16px', marginBottom: 10, borderLeft: '4px solid #d1d5db' },
            termLabel: { fontSize: 11, fontWeight: 700, color: '#4f46e5', textTransform: 'uppercase', letterSpacing: '0.5px' },
            paidBadge: { background: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0', borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700 },
            pendingBadge: { background: '#fef3c7', color: '#92400e', border: '1px solid #fde68a', borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700 },
        };

        const allTerms = selectedRow.all_terms || [];
        const paidTotal = allTerms.filter(t => t.is_paid == 1).reduce((s, t) => s + (t.term_amount || 0), 0);
        const pendingTotal = (selectedRow.total_amount || 0) - paidTotal;

        return (
            <Modal show={showModal} onHide={this.closeModal} size="lg" centered>
                <Modal.Header closeButton style={{ background: '#ffffff', borderBottom: '1px solid #f1f5f9', padding: '20px 24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <div style={{
                            width: 38,
                            height: 38,
                            borderRadius: 10,
                            background: '#e0e7ff',
                            border: '1px solid #c7d2fe',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#4f46e5',
                            fontSize: 16,
                            flexShrink: 0
                        }}>
                            <i className="fal fa-file-invoice-dollar" />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                            <Modal.Title style={{ color: '#0f172a', fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: '-0.01em' }}>Payment Details</Modal.Title>
                            <span style={{ color: '#64748b', fontSize: 12, fontWeight: 500, marginTop: 2 }}>Breakdown of fee terms and transaction receipts</span>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body style={{ padding: 24, background: '#f8fafc' }}>
                    {/* Student Info */}
                    <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', padding: '16px 20px', marginBottom: 16 }}>
                        <Row>
                            <Col lg={4} md={6} sm={12} className="mb-3">
                                <div style={S.infoBox}>
                                    <span style={S.label}>Student Name</span>
                                    <span style={S.value}>{selectedRow.student_name}</span>
                                </div>
                            </Col>
                            <Col lg={4} md={6} sm={12} className="mb-3">
                                <div style={S.infoBox}>
                                    <span style={S.label}>Adm No</span>
                                    <span style={S.value}>{selectedRow.roll_no}</span>
                                </div>
                            </Col>
                            <Col lg={4} md={6} sm={12} className="mb-3">
                                <div style={S.infoBox}>
                                    <span style={S.label}>Mobile</span>
                                    <span style={S.value}>{selectedRow.student_mobile || '-'}</span>
                                </div>
                            </Col>
                            <Col lg={4} md={6} sm={12} className="mb-3">
                                <div style={S.infoBox}>
                                    <span style={S.label}>Class</span>
                                    <span style={S.value}>{selectedRow.class_name}</span>
                                </div>
                            </Col>
                            <Col lg={4} md={6} sm={12} className="mb-3">
                                <div style={S.infoBox}>
                                    <span style={S.label}>Branch</span>
                                    <span style={S.value}>{selectedRow.branch_name}</span>
                                </div>
                            </Col>
                            <Col lg={4} md={6} sm={12} className="mb-3">
                                <div style={S.infoBox}>
                                    <span style={S.label}>Fee Type</span>
                                    <span style={S.value}>{selectedRow.fee_type}</span>
                                </div>
                            </Col>
                        </Row>

                        {/* Summary Strip */}
                        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 4 }}>
                            <div style={{ background: 'linear-gradient(135deg,#10b981,#059669)', borderRadius: 10, padding: '10px 20px', color: '#fff', textAlign: 'center', minWidth: 130 }}>
                                <div style={{ fontSize: 11, opacity: 0.85, fontWeight: 600, textTransform: 'uppercase' }}>Total Fee</div>
                                <div style={{ fontSize: 18, fontWeight: 800 }}>₹{(selectedRow.total_amount || 0).toLocaleString()}</div>
                            </div>
                            <div style={{ background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', borderRadius: 10, padding: '10px 20px', color: '#fff', textAlign: 'center', minWidth: 130 }}>
                                <div style={{ fontSize: 11, opacity: 0.85, fontWeight: 600, textTransform: 'uppercase' }}>Paid</div>
                                <div style={{ fontSize: 18, fontWeight: 800 }}>₹{paidTotal.toLocaleString()}</div>
                            </div>
                            <div style={{ background: 'linear-gradient(135deg,#f59e0b,#d97706)', borderRadius: 10, padding: '10px 20px', color: '#fff', textAlign: 'center', minWidth: 130 }}>
                                <div style={{ fontSize: 11, opacity: 0.85, fontWeight: 600, textTransform: 'uppercase' }}>Pending</div>
                                <div style={{ fontSize: 18, fontWeight: 800 }}>₹{Math.max(0, pendingTotal).toLocaleString()}</div>
                            </div>
                        </div>
                    </div>

                    {/* Term Cards */}
                    <div style={{ fontWeight: 700, fontSize: 13, color: '#4f46e5', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Term-wise Payments
                    </div>
                    {allTerms.length === 0 ? (
                        <div style={{ color: '#9ca3af', textAlign: 'center', padding: 20 }}>No term data available.</div>
                    ) : allTerms.map((term, idx) => {
                        const isPaid = term.is_paid == 1;
                        const termLabel = term.term_no == 0 ? 'Initial Payment' : `Term ${term.term_no}`;
                        const paymentMode = this.props.getPaymentModes
                            ? (this.props.getPaymentModes.find(p => p.id == term.payment_mode_id) || {}).payment_mode || '-'
                            : '-';

                        return (
                            <div key={idx} style={isPaid ? S.termCardPaid : S.termCardUnpaid}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                    <span style={S.termLabel}>{termLabel}</span>
                                    <span style={isPaid ? S.paidBadge : S.pendingBadge}>{isPaid ? 'Paid' : 'Pending'}</span>
                                </div>
                                <Row>
                                    <Col lg={3} md={4} sm={6} className="mb-2">
                                        <span style={S.label}>Amount</span>
                                        <span style={{ ...S.value, color: isPaid ? '#15803d' : '#92400e' }}>₹{(term.term_amount || 0).toLocaleString()}</span>
                                    </Col>
                                    {term.term_no != 0 && term.term_date && (
                                        <Col lg={3} md={4} sm={6} className="mb-2">
                                            <span style={S.label}>Due Date</span>
                                            <span style={S.value}>{moment.unix(parseInt(term.term_date)).format('DD-MM-YYYY')}</span>
                                        </Col>
                                    )}
                                    {isPaid && (
                                        <>
                                            <Col lg={3} md={4} sm={6} className="mb-2">
                                                <span style={S.label}>Paid Date</span>
                                                <span style={S.value}>{term.paid_date ? moment.unix(parseInt(term.paid_date)).format('DD-MM-YYYY') : '-'}</span>
                                            </Col>
                                            <Col lg={3} md={4} sm={6} className="mb-2">
                                                <span style={S.label}>Payment Mode</span>
                                                <span style={S.value}>{paymentMode}</span>
                                            </Col>
                                            {term.comments && (
                                                <Col lg={6} md={6} sm={12} className="mb-2">
                                                    <span style={S.label}>Comments</span>
                                                    <span style={S.value}>{term.comments}</span>
                                                </Col>
                                            )}
                                            {term.payment_id && (
                                                <Col lg={3} md={4} sm={6} className="mb-2">
                                                    <span style={S.label}>Receipt No</span>
                                                    <span style={S.value}>{term.payment_id}</span>
                                                </Col>
                                            )}
                                        </>
                                    )}
                                </Row>
                            </div>
                        );
                    })}
                </Modal.Body>

                <Modal.Footer style={{ background: '#fff', borderTop: '1px solid #e5e7eb', padding: '14px 24px' }}>
                    <button
                        onClick={this.closeModal}
                        style={{ background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', border: 'none', borderRadius: 10, padding: '9px 24px', fontWeight: 700, fontSize: 14, color: '#fff', cursor: 'pointer' }}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        const { fromDate, toDate } = this.state;
        const rows = this.getDateWiseRows();
        const totalCollected = rows.reduce((sum, r) => sum + (r.term_amount || 0), 0);

        const S = {
            page: { padding: '8px 0' },
            card: { background: '#fff', borderRadius: 20, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', border: 'none', marginBottom: 24, overflow: 'hidden' },
            cardHeader: {
                background: '#ffffff',
                padding: '20px 24px',
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                borderBottom: '1px solid #f1f5f9',
            },
            iconWrapperFilter: {
                width: 38,
                height: 38,
                borderRadius: 10,
                background: '#e0e7ff',
                border: '1px solid #c7d2fe',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#4f46e5',
                fontSize: 16,
                flexShrink: 0,
            },
            iconWrapperList: {
                width: 38,
                height: 38,
                borderRadius: 10,
                background: '#f5f3ff',
                border: '1px solid #ddd6fe',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#7c3aed',
                fontSize: 16,
                flexShrink: 0,
            },
            cardTitleText: {
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'left',
            },
            cardTitle: {
                color: '#0f172a',
                fontWeight: 700,
                fontSize: 16,
                margin: 0,
                letterSpacing: '-0.01em',
            },
            cardSubtitle: {
                color: '#64748b',
                fontSize: 12,
                fontWeight: 500,
                marginTop: 2,
            },
            label: { fontSize: 12, fontWeight: 600, color: '#6b7280', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block' },
            input: { borderRadius: 10, border: '1.5px solid #e5e7eb', padding: '9px 14px', fontSize: 14, color: '#1f2937', background: '#f9fafb', width: '100%' },
            countChip: {
                background: '#f5f3ff',
                color: '#7c3aed',
                borderRadius: 20,
                padding: '4px 12px',
                fontWeight: 600,
                fontSize: 12,
                border: '1px solid #ddd6fe',
                marginLeft: 'auto',
            },
            statCard: (g) => ({ background: g, borderRadius: 16, padding: '18px 22px', color: '#fff', display: 'flex', alignItems: 'center', gap: 16, boxShadow: '0 4px 16px rgba(0,0,0,0.10)' }),
            statIcon: { fontSize: 28, opacity: 0.85 },
            statLabel: { fontSize: 12, opacity: 0.85, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' },
            statValue: { fontSize: 22, fontWeight: 800, lineHeight: 1.2 },
        };

        return (
            <div style={S.page}>

                {/* Filter Card */}
                <div style={S.card}>
                    <div style={S.cardHeader}>
                        <div style={S.iconWrapperFilter}>
                            <i className="fal fa-calendar-alt" />
                        </div>
                        <div style={S.cardTitleText}>
                            <h5 style={S.cardTitle}>Date Wise Fee Collection</h5>
                            <span style={S.cardSubtitle}>Filter and view fee collections by date range</span>
                        </div>
                    </div>
                    <div style={{ padding: '20px 24px' }}>
                        <Row className="align-items-end g-3">
                            <Col lg={3} md={4} sm={6}>
                                <label style={S.label}>From Date</label>
                                <input type="date" value={fromDate} onChange={(e) => this.setState({ fromDate: e.target.value })} style={S.input} />
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <label style={S.label}>To Date</label>
                                <input type="date" value={toDate} onChange={(e) => this.setState({ toDate: e.target.value })} style={S.input} />
                            </Col>
                        </Row>
                    </div>
                </div>

                {/* Summary Stats */}
                <Row className="mb-4">
                    <Col lg={3} md={6} sm={12} className="mb-3">
                        <div style={S.statCard('linear-gradient(135deg, #10b981 0%, #059669 100%)')}>
                            <i className="fal fa-rupee-sign" style={S.statIcon} />
                            <div>
                                <div style={S.statLabel}>Total Collected</div>
                                <div style={S.statValue}>₹{totalCollected.toLocaleString()}</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={3} md={6} sm={12} className="mb-3">
                        <div style={S.statCard('linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)')}>
                            <i className="fal fa-list" style={S.statIcon} />
                            <div>
                                <div style={S.statLabel}>Total Transactions</div>
                                <div style={S.statValue}>{rows.length}</div>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Table Card */}
                <div style={S.card}>
                    <div style={S.cardHeader}>
                        <div style={S.iconWrapperList}>
                            <i className="fal fa-receipt" />
                        </div>
                        <div style={S.cardTitleText}>
                            <h5 style={S.cardTitle}>Payment Records</h5>
                            <span style={S.cardSubtitle}>Detailed log of all student transactions within the selected dates</span>
                        </div>
                        <span style={S.countChip}>{rows.length} records</span>
                    </div>
                    <div style={{ padding: '16px 24px' }}>
                        {rows.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '32px 0', color: '#9ca3af', fontSize: 15 }}>
                                No payments found for the selected date range.
                            </div>
                        ) : (
                            <CardLessDataTable
                                parentData={rows}
                                particlecolumns={this.Columns()}
                                search={true}
                                name="date_wise_fee_list"
                            />
                        )}
                    </div>
                </div>

                {this.renderModal()}
            </div>
        );
    }
}

export default DateWiseFeeSection;
